import { createContext } from 'react'

import type { AuthContextType } from './AuthorizationType'

const AuthContext = createContext<AuthContextType | undefined>(undefined)
export default AuthContext
